import api from '@/api'
import axios from 'axios'

//获得省市区
export async function getAreas(data) {
  return  api.post('/api/services/app/CommonLookup/DoGetAreas', data)
}

//获取七牛上传Token 
export async function getQiNiuUploadToken(){
  return api.get('/api/services/app/CommonLookup/GetQiNiuUploadToken') 
 }
 
 export async function uploadQiNiuVideo(url,data){
   return api.post(url,data) 
  }

  export async function uploadQiNiuFile(url,data){
    if(url)
    {
      return axios.create({
        url,
        timeout: 10000,
        headers: {
          'Content-Type': 'application/json',
        },
      }).post(url,data);
    }
    else{
       return api.post(url,data) 
    }
   }

   //获取阿里上传Token 
export async function getALiUploadToken() {
  return api.get('/api/services/app/CommonLookup/GetALiUploadToken')
}
export async function uploadALiFile(url, param) {
  return axios({
    url,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    data: param
  })
}




// WEBPACK FOOTER //
// ./src/api/commonLookup.js